import { DeviceSelection } from "@/interfaces/devices/selection";

export interface DeviceIds {
  audioInput: string;
  audioOutput: string;
  videoInput: string;
  videoQuality: string;
}

const DevicesStorageKey = "DEVICES";
export const storeDevices = async (devices: DeviceSelection): Promise<void> => {
  console.log(devices);
  localStorage.setItem(
    DevicesStorageKey,
    JSON.stringify({
      audioInput: devices.audioInput?.deviceId,
      audioOutput: devices.audioOutput?.deviceId,
      videoInput: devices.videoInput?.deviceId,
      videoQuality: devices.videoQuality,
      isVideoOn: devices.isVideoOn,
      isMicrophoneOn: devices.isMicrophoneOn
    })
  );
  return Promise.resolve();
};

export const loadDevices = async (): Promise<DeviceIds> => {
  const devices = JSON.parse(localStorage.getItem(DevicesStorageKey) || "{}");
  devices.isVideoOn = devices.isVideoOn === false ? false : true;
  devices.isMicrophoneOn = devices.isMicrophoneOn === false ? false : true;
  return Promise.resolve(devices);
};
